import React, { useEffect, useState } from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
const purchases = [['Marco R.', 'Milano', 'EDUFIS PRONTO™ — Pacchetto completo'], ['Elena B.', 'Bologna', 'EDUFIS PRONTO™ — Pacchetto completo'], ['Luca P.', 'Roma', 'EDUFIS PRONTO™ — Pacchetto completo'], ['Giulia F.', 'Torino', 'EDUFIS PRONTO™ — Pacchetto completo']];
export function PurchasePopup() {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [purchase, setPurchase] = useState(purchases[0]);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    let cycleTimer: number;
    const show = () => {
      setPurchase(purchases[Math.floor(Math.random() * purchases.length)]);
      setVisible(true);
      hideTimer = window.setTimeout(() => {
        setVisible(false);
        cycleTimer = window.setTimeout(show, 28000 + Math.floor(Math.random() * 14000));
      }, 5000);
    };
    const initialTimer = window.setTimeout(show, 15000);
    return () => {
      window.clearTimeout(initialTimer);
      window.clearTimeout(hideTimer);
      window.clearTimeout(cycleTimer);
    };
  }, [dismissed]);
  if (dismissed) return null;
  return <aside aria-live="polite" className={`fixed bottom-4 left-4 z-50 w-[calc(100%-2rem)] max-w-sm transition-all duration-500 ${visible ? 'translate-x-0 opacity-100' : '-translate-x-[120%] opacity-0'}`} data-id="element-200" data-mp="1fv969nx6oyag">
      <div className="relative border border-emerald-950/10 bg-white p-4 pr-10 shadow-2xl" data-id="element-201" data-mp="n97o9fsam29b">
        <button type="button" aria-label="Chiudi la notifica di acquisto recente" onClick={() => setDismissed(true)} className="absolute right-2 top-2 p-1 text-slate-500 hover:text-[#09281d]" data-id="element-202" data-mp="i9v452st39af">
          <XIcon className="h-4 w-4" data-id="element-203" data-mp="28jyahvtjdjqf" />
        </button>
        <p className="flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-widest text-emerald-800" data-id="element-204" data-mp="28imyj8pxt5o8">
          <span className="grid h-4 w-4 place-items-center rounded-full bg-emerald-500" data-id="element-205" data-mp="23npn5v56qk86">
            <CheckIcon className="h-3 w-3 text-white" data-id="element-206" data-mp="2aqntgu81pz6e" />
          </span>
          Acquisto verificato
        </p>
        <p className="mt-3 text-sm font-semibold text-[#09281d]" data-id="element-207" data-mp="2kmr7axc9fm96">
          <strong data-id="element-208" data-mp="2knah1qrrb4c4">{purchase[0]}</strong> da {purchase[1]}
        </p>
        <p className="mt-1 text-xs font-medium text-slate-600" data-id="element-209" data-mp="2pm3u5i34stbr">
          ha appena acquistato{' '}
          <span className="font-bold text-emerald-800" data-id="element-210" data-mp="1ryv3l8o9wu2w">{purchase[2]}</span>
        </p>
      </div>
    </aside>;
}